import { Id, MultiChangeEvent, PagedMultiSelectField, laravelSelectFetchConfig } from "@dgs/core";
import { FC } from "react";
import { eventService } from "../../api/eventService";
import { userResponsibilityService } from "../../api/userResponsibilityService";
import { UserResponsibilityResource } from "../../types/userResponsibility";

interface Props {
	name: string;
	label: string;
	onChange?: (e: MultiChangeEvent<UserResponsibilityResource>) => void;
	required?: boolean;
}

export const UserResponsibilitySelect: FC<Props> = ({ name, label, required, onChange }) => {
	return (
		<PagedMultiSelectField
			fetchConfig={laravelSelectFetchConfig(userResponsibilityService.optionsKey, (search, page) =>
				userResponsibilityService.options(search, page).then(({ data }) => data),
			)}
			name={name}
			label={label}
			clearable={true}
			getLabel={({ name }) => name}
			onChange={onChange}
			required={required}
		/>
	);
};

interface UserResponsibilityByEventSelectProps extends Props {
	eventId: Id;
}

export const UserResponsibilityByEventSelect: FC<UserResponsibilityByEventSelectProps> = ({
	name,
	label,
	required,
	onChange,
	eventId,
}) => {
	return (
		<PagedMultiSelectField
			fetchConfig={laravelSelectFetchConfig(eventService.userResponsibilityKey(eventId), (search, page) =>
				eventService.getUserResponsibilityOptions(eventId, search, page).then(({ data }) => data),
			)}
			name={name}
			label={label}
			clearable={true}
			getLabel={({ name }) => name}
			onChange={onChange}
			required={required}
		/>
	);
};
